export default defineNuxtPlugin(async () => {
    const localeCode = useLocaleCode();

    if (localeCode?.value) {
        useNuxtApp().$i18n.setLocale(localeCode.value)
    }
});
